require('../../modules/es6.string.iterator');

require('../../modules/web.dom.iterable');

module.exports = require('../../modules/$.wks')('iterator');